import { Link } from 'react-router-dom';

export function getStorefrontMapUrl({ latitude, longitude, address }) {
  const hasPin = latitude != null && longitude != null;
  if (hasPin) {
    return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
  }
  return address
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
    : null;
}

export function StorefrontLoading({ label = 'فروشگاه' }) {
  return (
    <section className="storefront-loading container" aria-label={`در حال بارگذاری ${label}`}>
      <div className="storefront-skeleton-hero skeleton" />
      <div className="storefront-skeleton-identity skeleton" />
      <div className="vendor-products-grid" aria-hidden="true">
        {Array.from({ length: 4 }, (_, index) => (
          <div className="vendor-product-skeleton" key={index}>
            <span className="skeleton" />
            <span className="skeleton" />
          </div>
        ))}
      </div>
    </section>
  );
}

export function StorefrontNotFound({ label = 'فروشگاه' }) {
  return (
    <section className="storefront-not-found container">
      <span className="storefront-empty-icon" aria-hidden="true">
        <i className="fas fa-store-slash" />
      </span>
      <h1>{label} پیدا نشد</h1>
      <p>ممکن است نشانی تغییر کرده باشد یا این صفحه در دسترس نباشد.</p>
      <Link className="storefront-back storefront-not-found-link" to="/marketplace">
        <i className="fas fa-arrow-right" aria-hidden="true" /> بازگشت به فروشندگان
      </Link>
    </section>
  );
}

export default function StorefrontHero({
  name,
  banner,
  verified = false,
  productCount,
  location,
  address,
  latitude,
  longitude,
  phone,
}) {
  const mapUrl = getStorefrontMapUrl({ latitude, longitude, address });
  const subtitle = [location?.name_fa, location?.province_name_fa]
    .filter((value, index, list) => value && list.indexOf(value) === index)
    .join('، ');

  return (
    <>
      <div className="storefront-hero" aria-label={name}>
        {banner ? (
          <>
            <img className="storefront-hero-backdrop" src={banner} alt="" aria-hidden="true" />
            <img className="storefront-hero-image" src={banner} alt={`بنر ${name}`} />
          </>
        ) : (
          <div className="storefront-hero-placeholder" />
        )}
        <div className="storefront-hero-shade" />
      </div>

      <div className="container storefront-identity-wrap">
        <section className="storefront-identity">
          <div className="storefront-avatar" aria-hidden="true">
            {name?.trim()?.[0] || <i className="fas fa-store" />}
          </div>
          <div className="storefront-identity-copy">
            <div className="storefront-name-line">
              <h1 title={name || 'فروشگاه'}>{name || 'فروشگاه'}</h1>
              {verified && (
                <span className="vendor-verified">
                  <i className="fas fa-check-circle" aria-hidden="true" /> تأییدشده
                </span>
              )}
            </div>
            {(productCount != null || subtitle || address) && (
              <div className="storefront-facts">
                {productCount != null && (
                  <span className="storefront-fact">
                    <i className="fas fa-box-open" aria-hidden="true" />
                    {productCount.toLocaleString('fa-IR')} محصول
                  </span>
                )}
                {subtitle && (
                  <span className="storefront-fact">
                    <i className="fas fa-map-marker-alt" aria-hidden="true" /> {subtitle}
                  </span>
                )}
                {address && (
                  <span className="storefront-fact storefront-address" title={address}>{address}</span>
                )}
              </div>
            )}
          </div>
          {(phone || mapUrl) && (
            <div className="storefront-actions">
              {phone && (
                <a className="storefront-action" href={`tel:${phone}`}>
                  <i className="fas fa-phone" aria-hidden="true" /> تماس
                </a>
              )}
              {mapUrl && (
                <a
                  className="storefront-action storefront-action-secondary"
                  href={mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fas fa-directions" aria-hidden="true" /> مسیریابی
                </a>
              )}
            </div>
          )}
        </section>
      </div>
    </>
  );
}
